<template>
    <kgr-offering-view
        v-if="offering !== null"
        :club-id="clubId"
        :offering="offering"
        :user-id="userId"
        :error="error"
        :duplicate-course-url="duplicateCourseUrl"
        :can-duplicate="canDuplicate"
        :can-edit="canEdit"
    />
</template>

<script>
import CourseOfferingRepository from '../../js/repository/club/offering/CourseOfferingRepository.js';
import Error from '../../js/model/Error.js';
import OfferingCourseView from '../../components/offering/OfferingCourseView.vue';

export default {
    components: {
        'kgr-offering-view': OfferingCourseView,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        offeringId: {
            type: String,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        duplicateCourseUrl: {
            type: String,
            required: true,
        },
        canDuplicate: {
            type: Boolean,
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showCalendar: true,
            showList: false,
            appointments: [],
            offering: null,
            error: new Error(),
        }
    },
    computed: {},
    created() {
        CourseOfferingRepository.find(this.offeringId)
            .then(offering => this.offering = offering)
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {},
}

</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
